import "./styles.scss";

const FramedButton = ({ text }) => {
  return (
    <a className="button" href="#contact">
      {text}
      <span className="above" />
      <span className="below" />
    </a>
  );
};

export default FramedButton;
